// Imports => Constants
import { KEYS } from '@opp/ui-kit';

// Imports => Utilities
import { AcIsSet, AcIsArray } from '@opp/ui-kit';

export class TransactionModel {
  constructor(rawData, parent_payment_method = null, options = {}) {
    this.rawData = rawData;
    this.options = options;

    return this.enrichData(parent_payment_method);
  }

  enrichData = (parent_payment_method) => {
    const clone = JSON.parse(JSON.stringify(this.rawData));

    if(this.rawData.parent_payment_method) {
      parent_payment_method = this.rawData.parent_payment_method;
    }

    return {
      ...clone,
      type: this.getType(clone),
      category: this.getCategory(clone),
      parent_payment_method: parent_payment_method,
    };
  };

  getType = (input) => {
    let result = null;

    if(input.hasOwnProperty('in')) {
      return input.in ? KEYS.INCOMING : KEYS.OUTGOING;
    }

    const { amount } = input;

    result = amount >= 0 ? KEYS.INCOMING : KEYS.OUTGOING;

    return result;
  };

  getCategory = (input) => {
    let result = null;

    const { escrow, refunds, status } = input;

    /*
            - completed
            - created
            - pending
            - planned
            - reserved
            - cancelled
            - failed
            - expired
            - refunded
            - chargeback
        */

    if (status === KEYS.CHARGEBACK) {
      result = KEYS.CHARGEBACK;
    } else if (status === KEYS.REFUNDED || status === KEYS.REFUND) {
      result = KEYS.REFUND;
    } else if (AcIsSet(refunds) && AcIsArray(refunds) && refunds.length > 0) {
      result = KEYS.REFUND;
    } else if (AcIsSet(escrow) && escrow.length > 0 || status === KEYS.RESERVED) {
      result = KEYS.ESCROW;
    } else {
      result = status;
    }

    return result;
  };
}

export default TransactionModel;
